import { Button, Stack, styled, Switch, Typography } from '@mui/material';

export const CookieBanner = styled('div')(() => ({
  position: 'fixed',
  right: '20px',
  bottom: '20px',
  left: '20px',
  zIndex: 1200,
  padding: '20px',
  backgroundColor: '#F8FAFE',
  border: '1px solid #F0EFFF',
  borderRadius: '20px',
}));

export const BannerInner = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  gap: theme.spacing(3),
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

export const BannerInnerBtns = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: theme.spacing(1.5),
  flexGrow: 1,
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'space-between',
  },
}));
export const BannerBtn = styled(Button)(({ theme }) => ({
  maxWidth: '154px',
  width: '100%',
  whiteSpace: 'nowrap',
  [theme.breakpoints.down('sm')]: {
    whiteSpace: 'wrap',
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1),
}));

export const Description = styled(Typography)(() => ({
  flexBasis: '70%',
}));

export const SettingsContent = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
  width: '100%',
}));

export const CategoriesList = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
}));

export const CategoryBlock = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const CategoryHeader = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '12px',
  width: '100%',
}));

export const CategorySwitch = styled(Switch)(() => ({
  flexShrink: 0,
  '&.Mui-disabled': {
    opacity: 1,
  },
  '& .MuiSwitch-switchBase.Mui-disabled': {
    color: '#FFFFFF',
    opacity: 1,
  },
  '& .MuiSwitch-switchBase.Mui-checked.Mui-disabled + .MuiSwitch-track': {
    backgroundColor: '#6948EB',
    opacity: '0.4 !important',
  },
}));

export const CategoryDescription = styled(Typography, {
  shouldForwardProp: prop => prop !== 'isExpanded',
})<{ isExpanded: boolean }>(({ isExpanded }) => {
  if (isExpanded) {
    return {
      width: '100%',
    };
  }

  return {
    width: '100%',
    maxHeight: '3em',
    overflow: 'hidden',
    WebkitMaskImage: 'linear-gradient(to bottom, #000 0%, rgba(0, 0, 0, 0.6) 50%, rgba(0, 0, 0, 0.2) 100%)',
    WebkitMaskSize: '100% 100%',
    WebkitMaskRepeat: 'no-repeat',
    maskImage: 'linear-gradient(to bottom, #000 0%, rgba(0, 0, 0, 0.6) 50%, rgba(0, 0, 0, 0.2) 100%)',
    maskSize: '100% 100%',
    maskRepeat: 'no-repeat',
  };
});

export const ToggleVisibilityButton = styled(Button)(() => ({
  minWidth: 'auto',
  width: 'fit-content',
  height: 'auto',
  padding: 0,
  fontWWeight: '500 !important',
  textDecoration: 'underline',
  justifyContent: 'flex-start',
  '&:hover': {
    backgroundColor: 'transparent',
  },
}));

export const InlineTextButton = styled(Button)(() => ({
  minWidth: 'auto',
  padding: 0,
  fontSize: 'inherit',
  fontWeight: 'inherit',
  lineHeight: 'inherit',
  verticalAlign: 'baseline',
  textTransform: 'none',
  textDecoration: 'underline',
  height: 'unset',
  '&:hover': {
    backgroundColor: 'transparent',
    textDecoration: 'underline',
  },
}));
